import Repository from "@/repositories/Repository";

// Verb 	    URI 	                Action 	  Route Name
// GET 	      /photos 	            index 	  photos.index
// GET 	      /photos/create 	      create 	  photos.create
// POST 	    /photos 	            store 	  photos.store
// GET 	      /photos/{photo} 	    show 	    photos.show
// GET 	      /photos/{photo}/edit 	edit 	    photos.edit
// PUT/PATCH 	/photos/{photo} 	    update 	  photos.update
// DELETE 	  /photos/{photo} 	    destroy 	photos.destroy

const resource = "/tasks";
export default {
  create() {
    // get the create form
    "/tasks/create";
    return Repository.get(`${resource}/create`);
  },
  edit(id) {
    // get the edit form
    return Repository.get(`${resource}/${id}/edit`);
  },
  validate(field, payload) {
    return Repository.post(`${resource}/validation/${field}`, payload);
  },
  index(queryString, config = {}) {
    // get the list
    return queryString
        ? Repository.get(`${resource}?${queryString}`, config)
        : Repository.get(`${resource}`, config);
  },
  show(id, relationString) {
    return relationString
      ? Repository.get(`${resource}/${id}/${relationString}`)
      : Repository.get(`${resource}/${id}`);
  },
  store(payload) {
    // save the item
    return Repository.post(`${resource}`, payload);
  },
  update(id, payload, queryString) {
    // update the item
    return queryString
      ? Repository.put(`${resource}/${id}?${queryString}`, payload)
      : Repository.put(`${resource}/${id}`, payload);
  },
  destroy(id, queryString) {
    // delete the item
    return queryString
      ? Repository.delete(`${resource}/${id}?${queryString}`)
      : Repository.delete(`${resource}/${id}`);
  },
  destroy_multiple(payload) {
    // delete a list of item ids, where payload = { ids: [1,2,...,N] }
    return Repository.delete(`${resource}/delete`, payload);
  },
  pivot_form(id, relation) {
    return Repository.get(`${resource}/${id}/pivot/${relation}`);
  },
  pivot_destroy(id, relation, payload) {
    return Repository.delete(`${resource}/${id}/pivot/${relation}`, {
      data: payload,
    });
  },
  pivot_store(id, relation, payload) {
    return Repository.post(`${resource}/${id}/pivot/${relation}`, payload);
  },
  pivot_update(id, relation, payload) {
    return Repository.put(`${resource}/${id}/pivot/${relation}`, payload);
  },
  show_memo() {
    // get the list of "active" memos
    return Repository.get(`${resource}?byMemo`);
  },
  destroy_memo(id) {
    // delete memos with "id"
    return Repository.delete(`memo/${id}`);
  },
};
